const ssn = {
    ssn : {
        value: "",
        dbqName: "form1[0].#subform[0].CommentsIfAny[1]"
     },
    examDate: {
        value: "",
        dbqName: "form1[0].#subform[0].CommentsIfAny[2]"
    },
     docName: {
         value: "",
         dbqName: "form1[0].#subform[12].SectionXIV-ExaminersCertSign[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "form1[0].#subform[12].SectionXIV-ExaminersCertSign[0].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "form1[0].#subform[12].SectionXIV-ExaminersCertSign[0].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "form1[0].#subform[12].SectionXIV-ExaminersCertSign[0].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "form1[0].#subform[12].SectionXIV-ExaminersCertSign[0].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "form1[0].#subform[12].SectionXIV-ExaminersCertSign[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "form1[0].#subform[12].SectionXIV-ExaminersCertSign[0].TextField8[5]"
    },
    diagnosisDate : [
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].Diagnoses1[0]_fv",
            sides: {
                right: "form1[0].#subform[0].SideR1[0]_fv",
                left: "form1[0].#subform[0].SideL1[0]_fv",
                both: "form1[0].#subform[0].SideB1[0]_fv",
                rightDateDbqName: "form1[0].#subform[0].DateOfDiagnosisR1[0]_fv",
                leftDateDbqName: "form1[0].#subform[0].DateOfDiagnosisL1[0]_fv"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].Diagnoses2[0]",
            sides: {
                right: "form1[0].#subform[0].SideR2[0]",
                left: "form1[0].#subform[0].SideL2[0]",
                both: "form1[0].#subform[0].SideB2[0]",
                rightDateDbqName: "form1[0].#subform[0].DateOfDiagnosisR2[0]",
                leftDateDbqName: "form1[0].#subform[0].DateOfDiagnosisL2[0]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].Diagnoses3[0]",
            sides: {
                right: "form1[0].#subform[0].SideR3[0]",
                left: "form1[0].#subform[0].SideL3[0]",
                both: "form1[0].#subform[0].SideB3[0]",
                rightDateDbqName: "form1[0].#subform[0].DateOfDiagnosisR3[0]",
                leftDateDbqName: "form1[0].#subform[0].DateOfDiagnosisL3[0]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].Diagnoses5[1]",
            sides: {
                right: "form1[0].#subform[0].SideR5[1]",
                left: "form1[0].#subform[0].SideL5[1]",
                both: "form1[0].#subform[0].SideB5[1]",
                rightDateDbqName: "form1[0].#subform[0].DateOfDiagnosisR5[1]",
                leftDateDbqName: "form1[0].#subform[0].DateOfDiagnosisL5[1]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].Diagnoses5[0]",
            sides: {
                right: "form1[0].#subform[0].SideR5[0]",
                left: "form1[0].#subform[0].SideL5[0]",
                both: "form1[0].#subform[0].SideB5[0]",
                rightDateDbqName: "form1[0].#subform[0].DateOfDiagnosisR5[0]",
                leftDateDbqName: "form1[0].#subform[0].DateOfDiagnosisL5[0]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].Diagnoses6[0]",
            sides: {
                right: "form1[0].#subform[0].SideR6[0]",
                left: "form1[0].#subform[0].SideL6[0]",
                both: "form1[0].#subform[0].SideB6[0]",
                rightDateDbqName: "form1[0].#subform[0].DateOfDiagnosisR6[0]",
                leftDateDbqName: "form1[0].#subform[0].DateOfDiagnosisL6[0]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].Diagnoses7[0]",
            sides: {
                right: "form1[0].#subform[0].SideR7[0]",
                left: "form1[0].#subform[0].SideL7[0]",
                both: "form1[0].#subform[0].SideB7[0]",
                rightDateDbqName: "form1[0].#subform[0].DateOfDiagnosisR7[0]",
                leftDateDbqName: "form1[0].#subform[0].DateOfDiagnosisL7[0]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses8[0]",
            sides: {
                right: "form1[0].#subform[4].SideR8[0]",
                left: "form1[0].#subform[4].SideL8[0]",
                both: "form1[0].#subform[4].SideB8[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR8[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL8[0]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses9[0]",
            sides: {
                right: "form1[0].#subform[4].SideR9[0]",
                left: "form1[0].#subform[4].SideL9[0]",
                both: "form1[0].#subform[4].SideB9[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR9[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL9[0]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses13[0]",
            sides: {
                right: "form1[0].#subform[4].SideR13[0]",
                left: "form1[0].#subform[4].SideL13[0]",
                both: "form1[0].#subform[4].SideB13[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR13[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL13[0]"
            },
        },    
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses14[0]",
            sides: {
                right: "form1[0].#subform[4].SideR14[0]",
                left: "form1[0].#subform[4].SideL14[0]",
                both: "form1[0].#subform[4].SideB14[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR14[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL14[0]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses15[0]",
            sides: {
                right: "form1[0].#subform[4].SideR15[0]",
                left: "form1[0].#subform[4].SideL15[0]",
                both: "form1[0].#subform[4].SideB15[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR15[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL15[0]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses16[0]",
            sides: {
                right: "form1[0].#subform[4].SideR16[0]",
                left: "form1[0].#subform[4].SideL16[0]",
                both: "form1[0].#subform[4].SideB16[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR16[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL16[0]"
            },
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses17[0]",
            sides: {
                right: "form1[0].#subform[4].SideR17[0]",
                left: "form1[0].#subform[4].SideL17[0]",
                both: "form1[0].#subform[4].SideB17[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR17[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL17[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses18[0]",
            sides: {
                right: "form1[0].#subform[4].SideR18[0]",
                left: "form1[0].#subform[4].SideL18[0]",
                both: "form1[0].#subform[4].SideB18[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR18[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL18[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses19[0]",
            sides: {
                right: "form1[0].#subform[4].SideR19[0]",
                left: "form1[0].#subform[4].SideL19[0]",
                both: "form1[0].#subform[4].SideB19[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR19[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL19[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses20[0]",
            sides: {
                right: "form1[0].#subform[4].SideR20[0]",
                left: "form1[0].#subform[4].SideL20[0]",
                both: "form1[0].#subform[4].SideB20[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR20[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL20[0]"
            },
        },               
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses21[0]",
            sides: {
                right: "form1[0].#subform[4].SideR21[0]",
                left: "form1[0].#subform[4].SideL21[0]",
                both: "form1[0].#subform[4].SideB21[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR21[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL21[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses23[0]",
            sides: {
                right: "form1[0].#subform[4].SideR23[0]",
                left: "form1[0].#subform[4].SideL23[0]",
                both: "form1[0].#subform[4].SideB23[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR23[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL23[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses26[0]",
            sides: {
                right: "form1[0].#subform[4].SideR26[0]",
                left: "form1[0].#subform[4].SideL26[0]",
                both: "form1[0].#subform[4].SideB26[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR26[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL26[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses27[0]",
            sides: {
                right: "form1[0].#subform[4].SideR27[0]",
                left: "form1[0].#subform[4].SideL27[0]",
                both: "form1[0].#subform[4].SideB27[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR27[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL27[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses28[0]",
            sides: {
                right: "form1[0].#subform[4].SideR28[0]",
                left: "form1[0].#subform[4].SideL28[0]",
                both: "form1[0].#subform[4].SideB28[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR28[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL28[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses29[0]",
            sides: {
                right: "form1[0].#subform[4].SideR29[0]",
                left: "form1[0].#subform[4].SideL29[0]",
                both: "form1[0].#subform[4].SideB29[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR29[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL29[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses31[0]",
            sides: {
                right: "form1[0].#subform[4].SideR30[0]",
                left: "form1[0].#subform[4].SideL30[0]",
                both: "form1[0].#subform[4].SideB30[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR30[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL30[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses33[0]",
            sides: {
                right: "form1[0].#subform[4].SideR31[0]",
                left: "form1[0].#subform[4].SideL31[0]",
                both: "form1[0].#subform[4].SideB31[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR31[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL31[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses35[0]",
            sides: {
                right: "form1[0].#subform[4].SideR32[0]",
                left: "form1[0].#subform[4].SideL32[0]",
                both: "form1[0].#subform[4].SideB32[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR32[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL32[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses36[0]",
            sides: {
                right: "form1[0].#subform[4].SideR33[0]",
                left: "form1[0].#subform[4].SideL33[0]",
                both: "form1[0].#subform[4].SideB33[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR33[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL33[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses36[1]",
            sides: {
                right: "form1[0].#subform[4].SideR34[0]",
                left: "form1[0].#subform[4].SideL34[0]",
                both: "form1[0].#subform[4].SideB34[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR34[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL34[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses36[2]",
            sides: {
                right: "form1[0].#subform[4].SideR35[0]",
                left: "form1[0].#subform[4].SideL35[0]",
                both: "form1[0].#subform[4].SideB35[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR35[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL35[0]"
            },
        },        
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[4].Diagnoses36[3]",
            sides: {
                right: "form1[0].#subform[4].SideR36[0]",
                left: "form1[0].#subform[4].SideL36[0]",
                both: "form1[0].#subform[4].SideB36[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR36[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL36[0]"
            },
        },
        {
            type: "text",
            dbqName: "form1[0].#subform[4].OtherDiagnosis39[0]",
            sides: {
                right: "form1[0].#subform[4].SideR39[0]",
                left: "form1[0].#subform[4].SideL39[0]",
                both: "form1[0].#subform[4].SideB39[0]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR39[0]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL39[0]"
            },
        },
        {
            type: "text",
            dbqName: "form1[0].#subform[4].OtherDiagnosis39[2]",
            sides: {
                right: "form1[0].#subform[4].SideR39[1]",
                left: "form1[0].#subform[4].SideL39[1]",
                both: "form1[0].#subform[4].SideB39[1]",
                rightDateDbqName: "form1[0].#subform[4].DateOfDiagnosisR39[1]",
                leftDateDbqName: "form1[0].#subform[4].DateOfDiagnosisL39[1]"
            },
        }
    ]
}

export default ssn ;